import React from 'react';
import {professionalAreas} from '../data/breads';
import SectionIntro from './SectionIntro';
import './Professional.css';

function Professional() {
  return (
    <section className="professional" id="professionelle" aria-labelledby="professional-title">
      <SectionIntro
        label="PROFESSIONELLE"
        title="FOR FOODSERVICE, DETAIL OG SAMARBEJDSPARTNERE"
      >
        <div className="professional-copy" id="professional-title">
          <p>
            Vi er interesserede i dialog med professionelle aktører, der arbejder med fladbrød,
            pita, naan og streetfood. Det kan være foodservicevirksomheder, grossister,
            distributører, detailhandlere eller andre potentielle samarbejdspartnere.
          </p>
          <p>
            South Eastern Bakery er fortsat under udvikling og er endnu ikke åbnet for almindeligt
            salg. Professionelle henvendelser og tidlig dialog er velkomne.
          </p>
        </div>
      </SectionIntro>
      <div className="professional-grid">
        {professionalAreas.map((area) => (
          <article className="professional-card" key={area.number}>
            <span>{area.number}</span>
            <h3>{area.title}</h3>
            <p>{area.text}</p>
          </article>
        ))}
      </div>
      <a className="button button-yellow" href="#kontakt">
        Tal med os om mulighederne
      </a>
    </section>
  );
}

export default Professional;